import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild,
  OnDestroy, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { IInputBoxItem } from '../../models/inputbox';

@Component({
  selector: 'sk-inputbox',
  templateUrl: './inputbox.component.html',
  styleUrls: ['./inputbox.component.scss']
})
export class InputBoxComponent implements OnInit, OnDestroy, OnChanges {
  @Input() id = new Date().getTime().toString();
  @Input() items: IInputBoxItem[] = [];
  @Input() placeHolder = '';
  @Input() defaultValue = '';
  @Input() clearValueOnChanged = false;
  @Output() clickedOutSide = new EventEmitter();
  @Output() selectedValue = new EventEmitter();
  @Output() dataListVisible = new EventEmitter();
  @Output() dataListVisibleInfo = new EventEmitter();
  @Output() dataListFiltered = new EventEmitter();
  @ViewChild('textSearch') textSearch: ElementRef;
  @ViewChild('listText') listText: ElementRef;
  inputText = '';
  filteredItems: IInputBoxItem[] = [];
  showList = false;
  currentIndex = 0;

  constructor() { }

  ngOnInit() {
    this.filteredItems = Object.assign([], this.items);
    if (this.defaultValue && this.defaultValue.length !== 0) {
      this.inputText = this.defaultValue;
    }
    window.addEventListener('scroll', this.scrollEvent, true);
    window.addEventListener('click', this.clickEvent, true);
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scrollEvent, true);
    window.removeEventListener('click', this.clickEvent, true);
  }

  scrollEvent = ($event: any): void => {
    if ($event.target.id !== this.id) {
      this.setListVisible(false);
    }
  }

  setListVisible(visible: boolean) {
    this.showList = visible;
    this.dataListVisible.emit(visible);
    this.dataListVisibleInfo.emit({
      id: this.id,
      visible: visible
    });
  }

  clickEvent = ($event: any): void => {
    if ($event && $event.path) {
      const clickedInComponent = $event.path.some((el: any) => el.className && el.className.includes === 'filter__content__container');
      this.clickedOutSide.emit(!clickedInComponent);
    }
  }

  clearOnChanged() {
    this.selectedValue.emit(this.inputText);
    setTimeout(() => {
      if (this.clearValueOnChanged) {
        this.inputText = '';
      }
    }, 100);
  }

  textChanged($event: any) {
    const value = $event.target.value;
    const tmpItems: IInputBoxItem[] = Object.assign([], this.items);
    if (value.length !== 0) {
      const filteredCustomers = tmpItems.filter(s => s.text.toLowerCase().includes(value.toLowerCase()));
      this.filteredItems =  Object.assign([], filteredCustomers);
    } else {
      this.filteredItems = tmpItems;
    }
    this.dataListFiltered.emit(this.filteredItems);
    this.selectedValue.emit(value);
    if (!$event.key || $event.key === 'Enter' || $event.key === 'Backspace') {
      if (this.filteredItems.length !== 0) {
        const item = this.filteredItems.find(c => c.selected);
        if (item) {
          this.inputText = item.text;
          item.selected = false;
        } else {
          this.inputText = value;
        }
        this.clearOnChanged();
        this.currentIndex = 0;
        if ($event.key === 'Backspace') {
          this.setListVisible(true);
        } else {
          this.setListVisible(false);
        }
        return;
      } else {
        this.clearOnChanged();
        this.setListVisible(false);
      }
      if ($event.key !== 'Backspace') {
        this.textSearch.nativeElement.blur();
      }
    } else if (!this.showList && this.filteredItems.length !== 0) {
      this.setListVisible(true);
    }
  }

  close() {
    this.textSearch.nativeElement.blur();
    this.setListVisible(false);
  }

  focus($event: any) {
    this.setListVisible(true);
  }

  selectValue(item: IInputBoxItem) {
    this.inputText = item.text;
    item.selected = true;
    this.items.filter(it => it.text !== item.text).forEach(it => {
      it.selected = false;
    });
    this.clearOnChanged();
    this.setListVisible(false);
  }

  moveDown() {
    if (this.currentIndex < this.filteredItems.length) {
      if (this.currentIndex === 0) {
        this.filteredItems[this.currentIndex].selected = true;
      } else {
        this.filteredItems[this.currentIndex - 1].selected = false;
        this.filteredItems[this.currentIndex].selected = true;
        this.listText.nativeElement.scrollTop += 25;
      }
      this.currentIndex++;
    }
  }

  moveUp() {
    if (this.currentIndex === 0) {
      return;
    }
    this.currentIndex--;
    if (this.currentIndex > 0) {
      this.filteredItems[this.currentIndex - 1].selected = true;
      this.filteredItems[this.currentIndex].selected = false;
      this.listText.nativeElement.scrollTop -= 25;
    } else {
      this.filteredItems[0].selected = true;
      this.filteredItems[1].selected = false;
    }
  }
}
